import { CloseSVG, EditSVG } from 'common/assets';
import stylesColors from 'common/styles/styles.colors';
import Separator from 'components/common/separator';
import { Input } from 'components/elements';
import { useFormState } from 'components/elements/form';
import { FullContainer } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import { Button, IconContainer } from './styles';

interface Props {
  name: string;
  clearable?: boolean;
  hasTime?: boolean;
  required?: boolean;
  label?: string | React.ReactNode;
  placeholder?: string;
}

export default function TransactionAt(props: Props) {
  const { t } = useTranslation();
  const {
    label = t('common:date'),
    placeholder = t('common:date'),
    ...rest
  } = props;
  const [transactionAtEditable, setTransactionAtEditable] =
    React.useState(true);

  const toggle = React.useCallback(
    () => setTransactionAtEditable((prev) => !prev),
    [],
  );

  const { editable } = useFormState();
  return (
    <>
      <FullContainer>
        <Input
          {...rest}
          type="date-time"
          label={label}
          placeholder={placeholder}
          disabled={transactionAtEditable}
        />
      </FullContainer>

      {editable && (
        <>
          <Separator gap={4} direction="horizontal" />
          <IconContainer>
            <Button onClick={toggle} isError={!transactionAtEditable}>
              {transactionAtEditable ? (
                <EditSVG size={18} color={stylesColors.primaryDefault} />
              ) : (
                <CloseSVG
                  width={18}
                  height={18}
                  color={stylesColors.redDefault}
                />
              )}
            </Button>
          </IconContainer>
        </>
      )}
    </>
  );
}
